import { SxProps } from "@mui/material";

export const tableContainerStyle: SxProps = {
  "&.MuiTableContainer-root": {
    borderRadius: 0,
  },
};
